import { useCallback, useEffect, useRef } from "react";
import { getNewScrollValue } from "../core/getNewScrollValue.js";
import { getStringifiedItemIds } from "../core/stringifiedItemIdsHelpers.js";
function useMaintainScrollPosition(props, scrollY, setScrollY, itemsWithPosition, renderedItems, scrollbarApiRef) {
  const { items, listHeight, updateScrollModeOnDataChange = "none" } = props;
  const api = useRef({ scrollY, listHeight, itemsWithPosition, updateScrollModeOnDataChange });
  useEffect(() => {
    api.current = { scrollY, listHeight, itemsWithPosition, updateScrollModeOnDataChange };
  }, [scrollY, listHeight, itemsWithPosition, updateScrollModeOnDataChange]);
  useEffect(() => {
    items;
    const { scrollY: scrollY2, listHeight: listHeight2, itemsWithPosition: itemsWithPosition2, updateScrollModeOnDataChange: updateScrollModeOnDataChange2 } = api.current;
    const oldVisibleItems = prevValues.current?.renderedItems;
    const oldStringifiedIds = prevValues.current?.stringifiedIds;
    if (oldVisibleItems && oldStringifiedIds) {
      scrollbarApiRef.current?.scrollTo(
        0,
        getNewScrollValue({
          oldVisibleItems,
          oldStringifiedIds,
          actualScroll: scrollY2,
          scrollHeight: listHeight2,
          newItems: itemsWithPosition2,
          updateScrollModeOnDataChange: updateScrollModeOnDataChange2
        })
      );
    }
  }, [scrollbarApiRef, items]);
  const prevValues = useRef();
  useEffect(() => {
    prevValues.current = {
      renderedItems,
      stringifiedIds: getStringifiedItemIds(itemsWithPosition)
    };
  }, [itemsWithPosition, renderedItems]);
  const onScroll = useCallback(
    (offset) => {
      setScrollY(offset.top);
    },
    [setScrollY]
  );
  return onScroll;
}
export {
  useMaintainScrollPosition
};
//# sourceMappingURL=useMaintainScrollPosition.js.map
